module.exports = __webpack_public_path__ + "img/1.0c1a9991.jpg";